<template>
  <div>
    <div style="display: flex">
      <div style="width: 72%">
        <div style="display: flex;justify-content: space-between">
          <div style="display: flex;flex-direction: column">
            <span>Pieces</span>
            <el-input-number
              no="1"
              :value="cargoDoc.quantity || undefined"
              :min="0"
              :max="999999999999"
              :precision="0"
              :disabled="!isEdit"
              controls-position="right"
              :controls="false"
              style="width:120px;margin-right:5px"
              :class="importDifferenceField.quantity ? 'red-border' : ''"
              @input="val=>{cargoDoc.quantity=val}"
            />
          </div>
          <div style="display: flex;flex-direction: column">
            <span>Gross Weight</span>
            <el-input-number
              no="2"
              :value="cargoDoc.weight || undefined"
              :min="0"
              :max="999999999999"
              :precision="3"
              :disabled="!isEdit"
              :controls="false"
              controls-position="right"
              style="width:120px;margin-right:5px"
              :class="importDifferenceField.weight ? 'red-border' : ''"
              @input="val=>{cargoDoc.weight=val}"
              @change="weightChangeHandler;commonChangeHandler('weight')"
            />
          </div>
          <div style="display: flex;flex-direction: column;margin-right: 2px;">
            <span>KG-LB</span>
            <el-select v-model="cargoDoc.kglb" :class="importDifferenceField.kglb ? 'red-border' : ''" :disabled="!isEdit" no="3" style="width: 70px;">
              <el-option label="K" value="K" />
              <el-option label="L" value="L" />
            </el-select>
          </div>
          <div style="display: flex;flex-direction: column;margin-right: 2px;">
            <span>Rate Class</span>
            <el-select v-model="cargoDoc.rateClass" :class="importDifferenceField.rateClass ? 'red-border' : ''" :disabled="!isEdit" no="4" :placeholder="!isEdit ? '' : $t('SeaExport.PleaseSelect')" style="width: 70px;" @change="rateClassChangeHandler">
              <el-option v-for="item in AirExportConstants.RATE_CLASSES" :key="item" :label="item" :value="item" />
            </el-select>
          </div>
          <div style="display: flex;flex-direction: column">
            <span>C.Weight</span>
            <el-input-number
              no="5"
              :value="cargoDoc.cWeight || undefined"
              :min="0"
              :max="999999999999"
              :precision="1"
              :disabled="!isEdit"
              controls-position="right"
              :controls="false"
              style="width:120px;margin-right:5px"
              :class="importDifferenceField.cWeight ? 'red-border' : ''"
              @input="val=>{cargoDoc.cWeight=val||0}"
              @change="cWeightChangeHandler();commonChangeHandler('cWeight')"
            />
          </div>
          <div style="display: flex;flex-direction: column;width: 100px;margin-right: 2px;">
            <span>Rate Charge</span>
            <el-input v-model="cargoDoc.rateCharge" :class="importDifferenceField.rateCharge ? 'red-border' : ''" :disabled="!isEdit" no="6" @change="commonChangeHandler('rateCharge')" />
          </div>
          <div style="display: flex;flex-direction: column;width: 100px;">
            <span>Total</span>
            <cargo-input
              v-model="cargoDoc.cTotal"
              :disabled="!isEdit"
              no="7"
              :auto-uppercase="true"
              :class="importDifferenceField.cTotal ? 'red-border' : ''"
              @blur="commonChangeHandler('cTotal')"
            />
          </div>

        </div>
        <div>
          <div style="display: flex;flex-direction: column;">
            <span>SLAC</span>
            <el-input-number :value="cargoDoc.slac || undefined" :disabled="!isEdit" :class="importDifferenceField.slac ? 'red-border' : ''" no="slac" style="width: 85px;" :min="0" :precision="0" :controls="false" @input="val=>{cargoDoc.slac=val||0}" />
          </div>
        </div>
        <div>
          <div style="display: flex;flex-direction: column;">
            <span>Remark</span>
            <cargo-rich-textarea
              v-model="cargoDoc.remark1"
              no="8"
              :text-chars="0"
              :warning-count="-1"
              :auto-uppercase="isUppercaseByConfig"
              style="height: 186px;"
              :disabled="!isEdit"
              :class="importDifferenceField.remark1 ? 'red-border' : ''"
              @blur="markChangeHandler()"
              @dblclick.native="showAdvanceTextDialog('Remark',cargoDoc.remark1,val=>{cargoDoc.remark1=val})"
            />
          </div>
        </div>
      </div>
      <div style="flex-grow: 1; width: 28%; margin-left: 5px;">
        <div style="display: flex;flex-direction: column">
          <span>Nature and Quantity of Goods</span>
          <cargo-rich-textarea
            v-model="cargoDoc.cargoEnglishName"
            no="9"
            :show-count="true"
            :disabled="!isEdit"
            :text-chars="0"
            :english-letter-auto-uppercase="isUppercaseByConfig"
            :warning-count="-1"
            :class="importDifferenceField.cargoEnglishName ? 'red-border' : ''"
            @blur="cargoEnglishNameChangeHandler()"
            @dblclick.native="showAdvanceTextDialog('Nature and Quantity of Goods',cargoDoc.cargoEnglishName,val=>{cargoDoc.cargoEnglishName=val},isUppercaseByConfig)"
          />

        </div>
        <div style="display: flex;flex-direction: column">
          <span>Dimension</span>

          <cargo-rich-textarea
            v-model="cargoDoc.dimension"
            no="10"
            :disabled="!isEdit"
            :text-chars="0"
            :warning-count="-1"
            :auto-uppercase="true"
            type="textarea"
            :rows="2"
            :class="importDifferenceField.dimension ? 'red-border' : ''"
            @dblclick.native="showAdvanceTextDialog('Dimension',cargoDoc.dimension,val=>{cargoDoc.dimension=val})"
          />
        </div>
        <div style="display: flex;flex-direction: column">
          <span>Volume</span>
          <el-input-number
            no="11"
            :value="cargoDoc.cubage || undefined"
            :min="0"
            :max="999999999999"
            :precision="3"
            :disabled="!isEdit"
            controls-position="right"
            :controls="false"
            style="width:100%;margin-right:5px"
            :class="importDifferenceField.cubage ? 'red-border' : ''"
            @input="val=>{cargoDoc.cubage=val}"
            @change="commonChangeHandler('cubage')"
          />
        </div>
      </div>

    </div>
    <div style="display: flex">
      <div style="margin-right: 5px;">
        <div>
          <div style="display: flex;justify-content: space-around">
            <span>Prepaid</span>
            <span>Weight Charge</span>
            <span>Collect</span>
          </div>
          <div style="display: flex;">
            <cargo-input
              v-model="cargoDoc.pp1"
              no="12"
              :auto-uppercase="true"
              :disabled="!isEdit || cargoDoc.wtVal !== AirExportConstants.PP"
              style="margin-right: 2px;"
              :class="importDifferenceField.pp1 ? 'red-border' : ''"
              @input="val=>{cargoDoc.pp1=val}"
              @change="commonChangeHandler('PP1')"
            />
            <cargo-input
              v-model="cargoDoc.cc1"
              no="13"
              :auto-uppercase="true"
              :disabled="!isEdit || cargoDoc.wtVal !== AirExportConstants.CC"
              :class="importDifferenceField.cc1 ? 'red-border' : ''"
              @input="val=>{cargoDoc.cc1=val}"
              @change="commonChangeHandler('CC1')"
            />
          </div>
        </div>
        <div>
          <div style="display: flex;justify-content: center">
            <span>Valuation</span>
          </div>
          <div style="display: flex;">
            <cargo-input
              v-model="cargoDoc.pp2"
              no="14"
              :auto-uppercase="true"
              :disabled="!isEdit || cargoDoc.wtVal !== AirExportConstants.PP"
              style="margin-right: 2px;"
              :class="importDifferenceField.pp2 ? 'red-border' : ''"
              @blur="commonChangeHandler('PP2')"
            />
            <cargo-input
              v-model="cargoDoc.cc2"
              no="15"
              :auto-uppercase="true"
              :class="importDifferenceField.cc2 ? 'red-border' : ''"
              :disabled="!isEdit || cargoDoc.wtVal !== AirExportConstants.CC"
              @blur="commonChangeHandler('CC2')"
            />
          </div>
        </div>
        <div>
          <div style="display: flex;justify-content: center">
            <span>Tax</span>
          </div>
          <div style="display: flex;">
            <cargo-input
              v-model="cargoDoc.pp3"
              no="16"
              :auto-uppercase="true"
              :disabled="!isEdit || cargoDoc.wtVal !== AirExportConstants.PP"
              style="margin-right: 2px;"
              :class="importDifferenceField.pp3 ? 'red-border' : ''"
              @blur="commonChangeHandler('PP3')"
            />
            <cargo-input
              v-model="cargoDoc.cc3"
              no="17"
              :auto-uppercase="true"
              :class="importDifferenceField.cc3 ? 'red-border' : ''"
              :disabled="!isEdit || cargoDoc.wtVal !== AirExportConstants.CC"
              @blur="commonChangeHandler('CC3')"
            />
          </div>
        </div>
        <div>
          <div style="display: flex;justify-content: center">
            <span>Total other Charges Due Agent</span>
          </div>
          <div style="display: flex;">
            <cargo-input
              v-model="cargoDoc.pp4"
              no="18"
              :auto-uppercase="true"
              :disabled="!isEdit || cargoDoc.other !== AirExportConstants.PP"
              style="margin-right: 2px;"
              :class="importDifferenceField.pp4 ? 'red-border' : ''"
              @input="val=>{cargoDoc.pp4=val}"
              @change="commonChangeHandler('PP4')"
            />
            <cargo-input
              v-model="cargoDoc.cc4"
              no="19"
              :auto-uppercase="true"
              :class="importDifferenceField.cc4 ? 'red-border' : ''"
              :disabled="!isEdit || cargoDoc.other !== AirExportConstants.CC"
              @input="val=>{cargoDoc.cc4=val}"
              @change="commonChangeHandler('CC4')"
            />
          </div>
        </div>
        <div>
          <div style="display: flex;justify-content: center;padding-top:7px; ">
            <span>Total other Charges Due Carrier</span>
          </div>
          <div style="display: flex;justify-content: center;">
            <cargo-input
              v-model="cargoDoc.pp5"
              no="20"
              :auto-uppercase="true"
              :disabled="true"
              style="margin-right: 2px;"
              @input="val=>{cargoDoc.pp5=val}"
              @change="commonChangeHandler('PP5')"
            />
            <cargo-input
              v-model="cargoDoc.cc5"
              no="21"
              :auto-uppercase="true"
              :disabled="true"
              @input="val=>{cargoDoc.cc5=val}"
              @change="commonChangeHandler('CC5')"
            />
          </div>
        </div>
        <div>
          <div style="display: flex;justify-content: space-around">
            <span>Total prepaid</span>
            <span>Total collect</span>
          </div>
          <div style="display: flex">
            <cargo-input
              v-model="cargoDoc.pp6"
              :disabled="!isEdit"
              no="22"
              :auto-uppercase="true"
              style="margin-right: 2px;"
              :class="importDifferenceField.pp6 ? 'red-border' : ''"
              @change="commonChangeHandler('PP6')"
            />
            <cargo-input
              v-model="cargoDoc.cc6"
              :disabled="!isEdit"
              no="23"
              :class="importDifferenceField.cc6 ? 'red-border' : ''"
              :auto-uppercase="true"
            />
          </div>
        </div>
      </div>
      <div>
        <div>
          <other-charge-grid ref="otherChargeGrid" :cargo-doc="cargoDoc" :action="action" :job="job" />
        </div>
        <div style="padding-top: 7px;">
          <span>Signature of Shipper or his Agent</span>
          <cargo-input
            v-model="cargoDoc.signByShipper"
            :disabled="!isEdit"
            no="24"
            :class="importDifferenceField.signByShipper ? 'red-border' : ''"
            :auto-uppercase="true"
          />
        </div>
        <div style="display: flex;">
          <div style="margin-right: 2px; display: flex; flex-direction: column;">
            <span>Executed on (date)</span>
            <el-date-picker
              v-model="cargoDoc.signDateBL"
              :disabled="!isEdit"
              no="25"
              clearable
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              :class="importDifferenceField.signDateBL ? 'red-border' : ''"
            />
          </div>
          <div style="margin-right: 2px;">
            <span>at (place)</span>
            <cargo-input
              v-model="cargoDoc.signPlaceBL"
              :disabled="!isEdit"
              no="26"
              :auto-uppercase="true"
              :class="importDifferenceField.signPlaceBL ? 'red-border' : ''"
            />
          </div>
          <div>
            <span>Signature of Issuing Carrier or its Agent</span>
            <cargo-input
              v-model="cargoDoc.signByCarrier"
              :disabled="!isEdit"
              no="27"
              :auto-uppercase="true"
              :class="importDifferenceField.signByCarrier ? 'red-border' : ''"
            />
          </div>
        </div>
      </div>
    </div>
    <!-- 高级文本弹框 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="advanceTextDialog.visible"
      :title="advanceTextDialog.title"
      width="600px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <cargo-rich-textarea
        v-model="advanceTextDialog.value"
        :disabled="!isEdit"
        :text-chars="0"
        :auto-uppercase="!advanceTextDialog.onlyEnglishLeterUppercase"
        :english-letter-auto-uppercase="advanceTextDialog.onlyEnglishLeterUppercase"
        :warning-count="-1"
        style="height: 320px;"
      />
      <span slot="footer">
        <el-button v-show="isEdit" no="28" type="primary" @click="finishAdvanceText">{{ $t('common.btn.confirm') }}</el-button>
        <el-button
          no="29"
          @click="advanceTextDialog.visible=false"
        >{{ $t('common.btn.close') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import * as AirExportConstants from '@/class/cargo/model/parameters/AirExportConstants'
import cargoRichTextarea from '@/components/Cargo/Common/cargoRichTextarea'
import OtherChargeGrid from './OtherChargeGrid'
import { IataPrice } from '@/class/model/sys/IataPrice'
import * as NumberUtils from '@/utils/NumberUtils'
import * as CargoDocConsts from '@/class/cargo/model/parameters/CargoDocConsts'
import { cache, cacheName } from '@/utils/cacheManager'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import CargoInput from '@/components/Cargo/Common/cargoInput'
import { AirCargoDocUtil } from '@/class/cargo/model/utils/AirCargoDocUtil'
import cargoTextarea from '@/components/Cargo/Common/cargoTextarea.vue'

const states = {
  readonly: 'readonly',
  editing: 'editing'
}
export default {
  name: 'HAWBPart1',
  components: {
    cargoTextarea,
    CargoInput,
    cargoRichTextarea, OtherChargeGrid
  },
  props: {
    action: { type: String, default: 'look' },
    cargoDoc: { type: Object },
    job: { type: Object },
    isUppercaseByConfig: {
      type: Boolean,
      default: () => true
    }
  },
  data() {
    return {
      states: states,
      AirExportConstants,
      advanceTextDialog: {
        visible: false,
        title: '',
        value: '',
        successCallback: null,
        onlyEnglishLeterUppercase: false
      },
      iataPrice: null,
      aEcWeightCeil: '',
      splitBubbleCollectionFormat: false, // 分泡收取格式
      airCargoMarkConfigValue: 0,
      airCargoEnglishNameConfigValue: 0
    }
  },
  computed: {
    isEdit() {
      return this.action !== 'look'
    },
    importDifferenceField() {
      if (!this.job) return {}
      if (this.cargoDoc.docType === CargoDocConsts.HAWB) {
        return this.job.differenceHawbFields || {}
      } else {
        return this.job.differenceMawbFields || {}
      }
    }
  },
  methods: {
    async fillView() {
      this.iataPrice = await JobUtils.queryIataPriceCarrier(this.job, this.iataPrice)
      await cache.load(cacheName.USER, cacheName.OFFICE, cacheName.CONFIG)
      this.aEcWeightCeil = Number(cache.config.get('AEcWeightCeil'))
      this.splitBubbleCollectionFormat = Number(cache.config.get('SplitBubbleCollectionFormat'))
      this.airCargoEnglishNameConfigValue = Number(cache.config.get('airCargoEnglishName'))
      this.airCargoMarkConfigValue = Number(cache.config.get('airCargoMark'))
      if (this.isEdit) { // 编辑
        if (this.cargoDoc && !this.cargoDoc.uuid) { // 新增的场景
          if (!this.cargoDoc.kglb) {
            this.cargoDoc.kglb = 'K'
          }
        }
        // CARGO-30906 ID：4976 恩跃 计费重量改变后，在HAWB页签重量*汇率显示的合计错误
        if (this.job && this.job.cWeightChange) {
          this.job.cWeightChange = false
          this.cWeightChangeHandler()
          this.commonChangeHandler('cWeight')
        }
      }
    },
    finishAdvanceText() {
      const successCallback = this.advanceTextDialog.successCallback
      if (successCallback && typeof successCallback === 'function') {
        successCallback(this.advanceTextDialog.value)
      }
      this.advanceTextDialog.visible = false
    },
    showAdvanceTextDialog(title, value, successCallback, onlyEnglishLeterUppercase = false) {
      this.advanceTextDialog.title = title
      this.advanceTextDialog.value = value
      this.advanceTextDialog.successCallback = successCallback
      this.advanceTextDialog.onlyEnglishLeterUppercase = onlyEnglishLeterUppercase
      this.advanceTextDialog.visible = true
    },
    refreshTotal(updateRC = true) {
      const iataPrice = this.iataPrice
      const cargoDoc = this.cargoDoc
      const rc = Number(cargoDoc.rateCharge || 0)
      if (iataPrice) {
        let level = new IataPrice(iataPrice).getPriceRange(cargoDoc.cWeight)
        if (updateRC) {
          if (level > 0) {
            // CARGO-39853，空运出口-MAWB/HAWB Rate Charge/Total/Other Charge 金额自动四舍五入取整
            cargoDoc.rateCharge = NumberUtils.formatNumberByCurrency(level, 2, cargoDoc.currency)
          } else {
            level = rc
          }
          const t = level * cargoDoc.cWeight
          if (t < iataPrice.levelM) {
            cargoDoc.rateClass = 'M'
            cargoDoc.cTotal = cargoDoc.rateCharge = NumberUtils.formatNumberByCurrency(iataPrice.levelM, 2, cargoDoc.currency)
          } else {
            if (cargoDoc.cWeight >= 0 && cargoDoc.cWeight < 45) {
              cargoDoc.rateClass = 'N'
            } else if (cargoDoc.cWeight >= 45) {
              cargoDoc.rateClass = 'Q'
            }
            cargoDoc.cTotal = NumberUtils.formatNumberByCurrency(this.replaceNaNWithZero(level * cargoDoc.cWeight), 2, cargoDoc.currency)
          }
        } else { // 兼容直接调整 rateCharge 的情况
          level = Number(cargoDoc.rateCharge || 0)
          if (cargoDoc.rateClass === 'M') {
            cargoDoc.cTotal = cargoDoc.rateCharge
          } else {
            cargoDoc.cTotal = NumberUtils.formatNumberByCurrency(cargoDoc.rateCharge * cargoDoc.cWeight, 2, cargoDoc.currency)
          }
        }
        return
      }
      if (isNaN(rc) || cargoDoc.rateClass === 'M') {
        cargoDoc.cTotal = cargoDoc.rateCharge
      } else {
        let cw = cargoDoc.cWeight
        cw = isNaN(cw) ? 0 : cw
        cargoDoc.cTotal = NumberUtils.formatNumberByCurrency(cw * rc, 2, cargoDoc.currency)
      }
    },
    // 以0替换NaN
    replaceNaNWithZero(num) {
      if (isNaN(num)) {
        return 0
      }
      return num
    },
    // 更新PP,CC值
    refreshPPCC() {
      if (!this.cargoDoc) return
      const cargoDoc = this.cargoDoc
      this.changeWtvalPosition(cargoDoc, 'pp1', 'cc1', cargoDoc.wtVal, cargoDoc.cTotal)
      this.changeWtvalPosition(cargoDoc, 'pp2', 'cc2', cargoDoc.wtVal)
      this.changeWtvalPosition(cargoDoc, 'pp3', 'cc3', cargoDoc.wtVal)
      if (cargoDoc.docType === CargoDocConsts.HAWB) {
        if (!cargoDoc.pp4 && !cargoDoc.cc4 && !cargoDoc.pp5 && !cargoDoc.cc5) {
          cargoDoc.pp4 = 'AS ARRANGED'
        }
        if (!cargoDoc.pp4 && !cargoDoc.cc4) {
          cargoDoc.pp4 = cargoDoc.pp5
          cargoDoc.cc4 = cargoDoc.cc5
          cargoDoc.pp5 = ''
          cargoDoc.cc5 = ''
        }
      }
      this.changeWtvalPosition(cargoDoc, 'pp4', 'cc4', cargoDoc.other)
      this.changeWtvalPosition(cargoDoc, 'pp5', 'cc5', cargoDoc.other)
      this.refreshPPCC6(cargoDoc)
    },
    // 刷新PPCC6
    refreshPPCC6(cargoDoc) {
      const pp1 = !cargoDoc.pp1 ? 0 : NumberUtils.parseNumber(cargoDoc.pp1, 2)
      const pp2 = !cargoDoc.pp2 ? 0 : NumberUtils.parseNumber(cargoDoc.pp2, 2)
      const pp3 = !cargoDoc.pp3 ? 0 : NumberUtils.parseNumber(cargoDoc.pp3, 2)
      const pp4 = !cargoDoc.pp4 ? 0 : NumberUtils.parseNumber(cargoDoc.pp4, 2)
      const pp5 = !cargoDoc.pp5 ? 0 : NumberUtils.parseNumber(cargoDoc.pp5, 2)
      if (!isNaN(pp1) && !isNaN(pp2) && !isNaN(pp3) && !isNaN(pp4) && !isNaN(pp5)) {
        const pp6 = pp1 + pp2 + pp3 + pp4 + pp5
        if (pp6 === 0) {
          cargoDoc.pp6 = ''
        } else {
          cargoDoc.pp6 = NumberUtils.formatNumber(pp6, 2)
        }
      } else if (!isNaN(pp1)) {
        cargoDoc.pp6 = cargoDoc.pp1
        if (cargoDoc.pp6 === 0) {
          cargoDoc.pp6 = ''
        }
      } else {
        if (cargoDoc.pp6 === 0) {
          cargoDoc.pp6 = ''
        }
      }

      const cc1 = !cargoDoc.cc1 ? 0 : NumberUtils.parseNumber(cargoDoc.cc1, 2)
      const cc2 = !cargoDoc.cc2 ? 0 : NumberUtils.parseNumber(cargoDoc.cc2, 2)
      const cc3 = !cargoDoc.cc3 ? 0 : NumberUtils.parseNumber(cargoDoc.cc3, 2)
      const cc4 = !cargoDoc.cc4 ? 0 : NumberUtils.parseNumber(cargoDoc.cc4, 2)
      const cc5 = !cargoDoc.cc5 ? 0 : NumberUtils.parseNumber(cargoDoc.cc5, 2)
      if (!isNaN(cc1) && !isNaN(cc2) && !isNaN(cc3) && !isNaN(cc4) && !isNaN(cc5)) {
        const cc6 = cc1 + cc2 + cc3 + cc4 + cc5
        if (cc6 === 0) {
          cargoDoc.cc6 = ''
        } else {
          cargoDoc.cc6 = NumberUtils.formatNumber(cc6, 2)
        }
      } else if (!isNaN(cc1)) {
        cargoDoc.cc6 = cargoDoc.cc1
        if (cargoDoc.cc6 === 0) {
          cargoDoc.cc6 = ''
        }
      } else {
        if (cargoDoc.cc6 === 0) {
          cargoDoc.cc6 = ''
        }
      }
    },
    changeWtvalPosition(cargoDoc, pp, cc, type, data) {
      if (!data) {
        data = !cargoDoc[pp] ? cargoDoc[cc] : cargoDoc[pp]
      }
      if (type === AirExportConstants.PP) {
        cargoDoc[pp] = data
        cargoDoc[cc] = ''
      } else if (type === AirExportConstants.CC) {
        cargoDoc[cc] = data
        cargoDoc[pp] = ''
      }
    },
    refreshOtherCharge() {
      if (!this.cargoDoc) return
      const cargoDoc = this.cargoDoc
      if (cargoDoc && cargoDoc.other && cargoDoc.otherCharge) {
        let total = 0
        for (const charge of cargoDoc.otherCharge) {
          if (charge.amount && !isNaN(charge.amount)) { total += Number(charge.amount) }
        }
        const isHawb = cargoDoc.docType === CargoDocConsts.HAWB
        if (!isHawb) { // MAWB
          if (cargoDoc.other === AirExportConstants.PP) {
            if (total !== 0) {
              cargoDoc.pp5 = NumberUtils.formatNumber(total, 2)
            } else {
              cargoDoc.pp5 = ''
            }
            cargoDoc.cc5 = ''
          } else if (cargoDoc.other === AirExportConstants.CC) {
            if (total !== 0) {
              cargoDoc.cc5 = NumberUtils.formatNumber(total, 2)
            } else {
              cargoDoc.cc5 = ''
            }
            cargoDoc.pp5 = ''
          }
        } else { // HAWB
          if (cargoDoc.other === AirExportConstants.PP) {
            if (total !== 0) {
              cargoDoc.pp4 = NumberUtils.formatNumber(total, 2)
            } else {
              cargoDoc.pp4 = ''
            }
            cargoDoc.cc4 = ''
          } else if (cargoDoc.other === AirExportConstants.CC) {
            if (total !== 0) {
              cargoDoc.cc4 = NumberUtils.formatNumber(total, 2)
            } else {
              cargoDoc.cc4 = ''
            }
            cargoDoc.pp4 = ''
          }
        }
      }
    },
    wtValChanged(str = '') {
      this.refreshPPCC()
    },
    otherChanged(str = '') {
      // CARGO-36728 恩跃：空运HAWB页面 Total other Charges Due Agent可以为空
      const isHawb = this.cargoDoc.docType === CargoDocConsts.HAWB
      if (!isHawb) { // MAWB
        const oldValue = this.cargoDoc.pp5 ? this.cargoDoc.pp5 : this.cargoDoc.cc5
        if (str === AirExportConstants.PP) {
          this.cargoDoc.pp5 = oldValue
        } else if (str === AirExportConstants.CC) {
          this.cargoDoc.cc5 = oldValue
        }
      } else {
        const oldValue = this.cargoDoc.pp4 ? this.cargoDoc.pp4 : this.cargoDoc.cc4
        if (str === AirExportConstants.PP) {
          this.cargoDoc.pp4 = oldValue
        } else if (str === AirExportConstants.CC) {
          this.cargoDoc.cc4 = oldValue
        }
      }
      this.refreshOtherCharge()
      this.refreshPPCC()
    },
    weightChangeHandler() {
      if (this.cargoDoc) {
        const c = this.cargoDoc.otherCharge
        for (const charge of c) {
          if (charge.measure === 'wt' && charge.unitRate > 0) {
            charge.amount = (isNaN(charge.unitRate) ? 0 : Number(charge.unitRate)) * (isNaN(this.cargoDoc.weight) ? 0 : Number(this.cargoDoc.weight))
          }
        }
        this.refreshOtherCharge()
        this.refreshPPCC()
      }
    },
    cWeightChangeHandler() {
      if (this.cargoDoc) {
        const c = this.cargoDoc.otherCharge
        if (c) {
          for (const charge of c) {
            if (charge.measure === 'chargeWeight' && charge.unitRate > 0) {
              charge.amount = (isNaN(charge.unitRate) ? 0 : Number(charge.unitRate)) * (isNaN(this.cargoDoc.cWeight) ? 0 : this.cargoDoc.cWeight)
            }
            if (charge.measure === 'quantity' && charge.unitRate > 0) {
              charge.amount = (isNaN(charge.unitRate) ? 0 : Number(charge.unitRate)) * (isNaN(this.cargoDoc.quantity) ? 0 : this.cargoDoc.quantity)
            }
          }
        }
        if (this.cargoDoc.cWeight === 0) {
          this.cargoDoc.rateCharge = ''
          this.cargoDoc.cTotal = ''
          this.cargoDoc.rateClass = ''
          this.refreshTotal(false)
          this.refreshPPCC()
        } else {
          this.refreshOtherCharge()
          this.refreshTotal(false)
          this.refreshPPCC()
        }
        if (this.$refs.otherChargeGrid && this.$refs.otherChargeGrid.gridApi) {
          this.$refs.otherChargeGrid.gridApi.refreshCells({ force: true })
        }
      }
    },
    totalChargeHandler() {
      if (this.iataPrice) {
        const cargoDoc = this.cargoDoc
        const w = isNaN(cargoDoc.cWeight) ? 0 : cargoDoc.cWeight
        const level = isNaN(new IataPrice(this.iataPrice).getPriceRange(w)) ? 0 : new IataPrice(this.iataPrice).getPriceRange(w)
        cargoDoc.rateCharge = NumberUtils.formatNumberByCurrency(level, 2, cargoDoc.currency)
        const t = level * w
        if (t < this.iataPrice.levelM) {
          if (w === 0) {
            cargoDoc.rateClass = ''
          } else {
            cargoDoc.rateClass = 'M'
          }
          cargoDoc.cTotal = cargoDoc.rateCharge = NumberUtils.formatNumberByCurrency(this.iataPrice.levelM, 2, cargoDoc.currency)
        } else {
          if (w >= 0 && w < 45) {
            cargoDoc.rateClass = 'N'
          } else if (w >= 45) {
            cargoDoc.rateClass = 'Q'
          }
          cargoDoc.cTotal = NumberUtils.formatNumberByCurrency(level * w, 2, cargoDoc.currency)
        }
      }
      this.refreshPPCC()
    },
    rateClassChangeHandler() {
      if (this.iataPrice && this.cargoDoc.docType === 'MAWB') {
        if (this.cargoDoc.rateClass === 'M') {
          this.cargoDoc.cTotal = NumberUtils.formatNumberByCurrency(this.iataPrice.levelM, 2, this.cargoDoc.currency)
          this.cargoDoc.rateCharge = NumberUtils.formatNumberByCurrency(this.iataPrice.levelM, 2, this.cargoDoc.currency)
        } else {
          const level = new IataPrice(this.iataPrice).getPriceRange(this.cargoDoc.cWeight)
          const t = level * (isNaN(this.cargoDoc.cWeight) ? 0 : this.cargoDoc.cWeight)
          if (t < this.iataPrice.levelM) {
            this.cargoDoc.rateClass = 'M'
            this.$message.warning(this.$t('queryJob.TheRateMAndAdjusted'))
            return
          }
          this.cargoDoc.rateCharge = NumberUtils.formatNumberByCurrency(level, 2, this.cargoDoc.currency)
          this.cargoDoc.cTotal = NumberUtils.formatNumberByCurrency(t, 2, this.cargoDoc.currency)
        }
      } else {
        if (this.cargoDoc.rateClass === 'M') {
          this.cargoDoc.cTotal = this.cargoDoc.rateCharge
        } else {
          this.refreshTotal()
        }
      }
      this.refreshPPCC()
    },
    async fillModel(submitData = false) {
      // CARGO-31455 12835 空运订舱HAWB remake 显示问题
      if (!this.isEdit) return
      if (submitData) {
        if (!this.cargoDoc.kglb) {
          this.cargoDoc.kglb = 'K'
        }
        if (CargoDocConsts.HAWB === this.cargoDoc.docType && !this.cargoDoc.pp4 && !this.cargoDoc.cc4 && !this.cargoDoc.pp5 && !this.cargoDoc.cc5) {
          if (this.cargoDoc.wtVal === AirExportConstants.PP) {
            this.cargoDoc.pp4 = 'AS ARRANGED'
          } else {
            this.cargoDoc.cc4 = 'AS ARRANGED'
          }
        }
        if (CargoDocConsts.HAWB === this.cargoDoc.docType && !this.cargoDoc.pp4 && !this.cargoDoc.cc4) {
          this.cargoDoc.cc4 = this.cargoDoc.cc5
          this.cargoDoc.pp4 = this.cargoDoc.pp5
        }
      }
    },
    commonChangeHandler(type = '') {
      if (!this.isEdit) return
      const cargoDoc = this.cargoDoc
      const prop = cargoDoc.docType === CargoDocConsts.HAWB ? this.job.pbProportion : this.job.pbProportion2
      switch (type) {
        case 'weight' :
        case 'cubage' :
          if (this.job.lob !== 'AE') {
            cargoDoc.cWeight = JobUtils.calcChargeWeight(cargoDoc.weight, cargoDoc.cubage)
          }
          cargoDoc.cWeight = JobUtils.calcProportion(prop, cargoDoc.weight, cargoDoc.cubage, cargoDoc.docType !== CargoDocConsts.HAWB, this.aEcWeightCeil, this.splitBubbleCollectionFormat)
          this.$emit('chargeWeightChange')
          this.refreshTotal()
          this.refreshPPCC()
          break
        case 'cWeight' :
          if (cargoDoc && (cargoDoc.docType === CargoDocConsts.HAWB || cargoDoc.docType === CargoDocConsts.HAWB2)) {
          } else {
            cargoDoc.cWeight = JobUtils.calcChargeWeight2(cargoDoc.cWeight, true, this.aEcWeightCeil)
          }
          if (cargoDoc.docType === 'HAWB' && cargoDoc.rateCharge === 'AS ARRANGED') {
            cargoDoc.cTotal = 'AS ARRANGED'
          }
          this.$emit('chargeWeightChange')
          break
        case 'rateCharge' :
          cargoDoc.rateCharge = NumberUtils.formatNumberByCurrency(cargoDoc.rateCharge, 2, cargoDoc.currency)
          this.refreshTotal(false)
          this.refreshPPCC()
          if (cargoDoc.docType === 'HAWB' && cargoDoc.rateCharge === 'AS ARRANGED') {
            cargoDoc.cTotal = 'AS ARRANGED'
          }
          break
        case 'cTotal':
          cargoDoc.cTotal = NumberUtils.formatNumberByCurrency(cargoDoc.cTotal, 2, cargoDoc.currency)
          break
        case 'PP1' :
        case 'CC1' :
        case 'PP5' :
        case 'CC5' :
          this.refreshPPCC()
          break
        case 'PP2' :
          cargoDoc.pp2 = NumberUtils.formatNumberByCurrency(cargoDoc.pp2, 2, cargoDoc.currency)
          break
        case 'CC2' :
          cargoDoc.cc2 = NumberUtils.formatNumberByCurrency(cargoDoc.cc2, 2, cargoDoc.currency)
          break
        case 'PP3' :
          cargoDoc.pp3 = NumberUtils.formatNumberByCurrency(cargoDoc.pp3, 2, cargoDoc.currency)
          break
        case 'CC3' :
          cargoDoc.cc3 = NumberUtils.formatNumberByCurrency(cargoDoc.cc3, 2, cargoDoc.currency)
          break
        case 'PP4' :
        case 'CC4' :
          this.refreshPPCC6(cargoDoc)
          break
        case 'PP6':
          this.refreshPPCC6(cargoDoc)
          break
        default :
          break
      }
    },
    cargoEnglishNameChangeHandler() {
      if (!this.isEdit) return
      AirCargoDocUtil.syncCargoEnglishName(this.job, this.cargoDoc, this.airCargoEnglishNameConfigValue, 1)
    },
    markChangeHandler() {
      if (!this.isEdit) return
      AirCargoDocUtil.syncMark(this.job, this.cargoDoc, this.airCargoMarkConfigValue, 1)
    }
  }
}
</script>

<style lang="scss" scoped>
.red-border {
  /deep/ .el-input__inner,
  /deep/ .el-textarea__inner,
  /deep/ .cargo-rich-textarea{
    border: 1px solid red !important;
  }
}
</style>
